/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		// We are using grid here instead of flex, so that if only a single DoDont is rendered,
		// it is aligned correctly with other rows that have multiple DoDonts.
		// It also means many DoDonts (>2) can be rendered within the same wrapper and flow onto new rows.
		display: 'grid',
		// On mobile, each element is full width.
		gridTemplateColumns: '1fr',
		'@media (min-width: 30rem)': {
			// On larger viewports, they are laid out in two columns.
			gridTemplateColumns: '1fr 1fr',
		},
		gap: token('space.200'),
		paddingBlockEnd: token('space.200'),
	},
});

/**
 * __DoDontGrid__
 *
 * Wrapper for DoDont components. It controls the layout of the DoDont components within the row,
 * so they are positioned side by side on small viewports, and stacked on larger viewports.
 *
 * @example
 * ```tsx
 * <DoDontGrid>
 *   <DoDont type="do" />
 *   <DoDont type="dont" />
 * </DoDontGrid>
 * ```
 */
export function DoDontGrid({ children }: { children: React.ReactNode }): JSX.Element {
	return <div css={styles.root}>{children}</div>;
}
